import states from "./States";
export const DefaultSearchFieldsPart = {
    categoryName: "Parts",
    fields : [
        {
            hideField: false,
            label: "Newest listings",
            fieldType: "sortonly",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "1",
            sortable: true,
            isBeingSorted: false,
            sortDirection: "desc"
        },
        {
            hideField: false,
            label: "Year",
            fieldType: "multiselect",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "2",
            sortable: true,
            isBeingSorted: true,
            isDefaultSort: true,
            sortDirection: "desc"
        },
        {
            hideField: false,
            label: "Manufacturer",
            fieldType: "select",
            searchValues: [],
            selectedValue: "",
            selectedValues: [],
            filterId: "3",
            sortable: true,
            sortDirection: "asc"
        },
        {
            hideField: false,
            label: "Model",
            fieldType: "select",
            searchValues: [],
            selectedValue: "",
            selectedValues: [],
            filterId: "4",
            sortable: false,
            sortDirection: "asc"
        },
        {
            hideField: false,
            label: "Category",
            fieldType: "select",
            searchValues: [],
            selectedValue: "",
            selectedValues: [],
            filterId: "34",
            sortable: false,
            sortDirection: "asc"
        },
        {
            hideField: false,
            label: "Stock #",
            fieldType: "textbox",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "28",
        },
        {
            hideField: false,
            label: "City",
            fieldType: "textbox",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "12",
        },
        {
            hideField: false,
            label: "State",
            fieldType: "multiselect",
            searchValues: states,
            selectedValue: "",
            selectedValues: [],
            filterId: "13",
        }
    ]
}